import { localeDict } from '@/consts/languageAccordance';
import { accountService } from '@/services';
import { useRouter } from '@/hooks/general';
import { addLocaleToUrl } from './addLocaleToUrl';
import { useCurrentPath } from '@/hooks/general/useCurrentPath/useCurrentPath';
import { useLocale } from '@/hooks/general/useLocale/useLocale';

interface UpdateLocaleParams {
    locale: string | undefined;
    isLoggedIn: boolean;
    router: ReturnType<typeof useRouter>;
    currentPath: ReturnType<typeof useCurrentPath>;
    i18nLocale: ReturnType<typeof useLocale>;
    setLocale: (locale: string) => void;
}

export const updateLocale = async ({
    locale,
    isLoggedIn,
    router,
    currentPath,
    i18nLocale,
    setLocale,
}: UpdateLocaleParams) => {
    if (!locale) return;
    if (locale === i18nLocale.locale) return;
    if (isLoggedIn) {
        const langId = localeDict[locale].language.id;
        await accountService.updatePersonalDetails({
            preferredLanguageId: langId,
        });
    }
    setLocale(locale);
    router.push(addLocaleToUrl(locale, currentPath.pathname, currentPath.asPath));
    // Refresh to fetch new content based on the updated locale
    router.refresh();
};
